import React from "react";
import Table from "material-ui/Table";
import { TableBody, TableCell, TableHead, TableRow } from "material-ui/Table";
import Paper from "material-ui/Paper";
import constants from "constants";

const titleLabel = {
  dr: "Dr.",
  mr: "Mr.",
  ms: "Ms.",
  mrs: "Mrs.",
  prof: "Prof.",
};

const roleToLabel = {
  gp: "GP",
  gp_trainee: "GP Trainee",
  nurse: "Nurse",
  consultant: "Consultant",
  hospital_doctor: "NCHD (Hospital Doctor)",
  nurse_specialist: "Nurse Specialist/ANP",
  allied_healthcare_professional: "Allied Healthcare Professional",
  pharmacist: "Pharmacy",
  // midwifery: "Midwife",
};

const { EXPORT_USERS_NEWSLETTER_CSV } = constants;

export default function NewsletterUsers({ values, webinarId }) {
  return (
    <div>
      <div className="block-registered-user">
        <div className="webinar-registered-users">
          Number of registered users
        </div>
        <div className="webinar-register-users">
          <span>({values.length})</span>
        </div>
      </div>
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Title</TableCell>
              <TableCell>Firstname</TableCell>
              <TableCell>Lastname</TableCell>
              <TableCell>County</TableCell>
              <TableCell>HCP</TableCell>
              <TableCell>Email</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {values.map((value) => (
              <TableRow>
                <TableCell>{titleLabel[value.title] || value.title}</TableCell>
                <TableCell>{value.first_name}</TableCell>
                <TableCell>{value.last_name}</TableCell>
                <TableCell>{value.county || "-"}</TableCell>
                <TableCell>
                  {roleToLabel[value.user_type] || value.user_type}
                </TableCell>
                <TableCell>{value.email}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
      {/*<a className="button_classic_session" href={`${EXPORT_USERS_NEWSLETTER_CSV}/${webinarId}`} target="_blank">*/}
      {/*  Export users*/}
      {/*</a>*/}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Admin/Webinar/NewsletterUsers.jsx